import React, { createRef } from 'react';
import { createRoot } from 'react-dom/client';
import HekateCommentStream from './HekateCommentStream';
window.mountHekateCommentStream = function mountHekateCommentStream(containerId, props) {
    const container = document.getElementById(containerId);
    if (!container) {
        console.error('HekateCommentStream: container not found:', containerId);
        return {
            type: 'comment-stream',
            unmount: () => { },
            get api() { return null; },
        };
    }
    const apiRef = createRef();
    const root = createRoot(container);
    root.render(React.createElement(HekateCommentStream, { ...props, ref: apiRef }));
    return {
        type: 'comment-stream',
        unmount: () => root.unmount(),
        get api() { return apiRef.current; },
    };
};
